import React from "react";
import ReactMarkdown from "markdown-to-jsx";
import {
  Box,
  Link,
  Typography,
  useTheme,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  ul: {
    marginLeft: theme?.spacing ? theme.spacing(2) : null,
    listStyle: "disc",
  },
  ol: {
    marginLeft: theme?.spacing ? theme.spacing(3) : null,
  },
}));

const CustomImage = ({ children, ...props }) => {
  return (
    <Box sx={{ textAlign: "center" }}>
      <img alt="Custom" {...props} style={{ maxWidth: "100%" }} />
    </Box>
  );
};

export default function MarkdownViewer({ source }) {
  const classes = useStyles();
  const theme = useTheme();

  const options = {
    overrides: {
      h1: {
        component: Typography,
        props: {
          gutterBottom: true,
          variant: "h1",
        },
      },
      h2: {
        component: Typography,
        props: { gutterBottom: true, variant: "h2" },
      },
      h3: {
        component: Typography,
        props: { gutterBottom: true, variant: "h3" },
      },
      h4: {
        component: Typography,
        props: { gutterBottom: true, variant: "h4" },
      },
      h5: {
        component: Typography,
        props: { gutterBottom: true, variant: "h5" },
      },
      p: {
        component: Typography,
        props: { paragraph: true },
      },
      a: {
        component: Link,
        props: { target: "_blank", rel: "noopener" },
      },
      ul: {
        props: { className: classes.ul },
      },
      ol: {
        props: { className: classes.ol },
      },
      img: {
        component: CustomImage,
      },
      table: {
        component: Table,
        props: {
          color: `${theme?.palette?.text?.primary} !important`,
          backgroundColor: `${theme?.palette?.background.tertiary} !important`,
          border: `1px solid ${theme?.palette?.text?.primary} !important`,
          textAlign: "center !important",
          fontWeight: "700 !important",
          padding: "10px 6px !important",
          wordBreak: "break-word !important",
        },
      },
      thead: {
        component: TableHead,
      },
      tr: {
        component: TableRow,
      },
      td: {
        component: TableCell,
      },
      tb: {
        component: TableBody,
      },
    },
    disableParsingRawHTML: true,
  };
  return <ReactMarkdown options={options}>{source}</ReactMarkdown>;
}
